const STORAGE_KEY = 'marvelous_tracking_params';

export interface TrackingParams {
  gclid?: string;
  fbclid?: string;
  fbc?: string;
  fbp?: string;
  ga_client_id?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function captureTrackingParams(): void {
  try {
    const params = new URLSearchParams(window.location.search);

    const stored: TrackingParams = JSON.parse(
      sessionStorage.getItem(STORAGE_KEY) || '{}'
    );

    // Extract tracking params from URL
    const gclid = params.get('gclid');
    const fbclid = params.get('fbclid');
    const utmSource = params.get('utm_source');
    const utmMedium = params.get('utm_medium');
    const utmCampaign = params.get('utm_campaign');
    const utmTerm = params.get('utm_term');
    const utmContent = params.get('utm_content');

    if (gclid) stored.gclid = gclid;
    if (fbclid) stored.fbclid = fbclid;
    if (utmSource) stored.utm_source = utmSource;
    if (utmMedium) stored.utm_medium = utmMedium;
    if (utmCampaign) stored.utm_campaign = utmCampaign;
    if (utmTerm) stored.utm_term = utmTerm;
    if (utmContent) stored.utm_content = utmContent;

    // Meta fbc/fbp: prefer URL param (forwarded by landing page), then cookie, then construct from fbclid
    const fbcParam = params.get('_fbc');
    if (fbcParam) {
      stored.fbc = fbcParam;
    } else {
      const fbcCookie = getCookie('_fbc');
      if (fbcCookie) {
        stored.fbc = fbcCookie;
      } else if (stored.fbclid || fbclid) {
        stored.fbc = `fb.1.${Date.now()}.${stored.fbclid || fbclid}`;
      }
    }

    const fbpParam = params.get('_fbp');
    if (fbpParam) {
      stored.fbp = fbpParam;
    } else {
      const fbpCookie = getCookie('_fbp');
      if (fbpCookie) {
        stored.fbp = fbpCookie;
      }
    }

    // GA4 client ID: from _ga cookie or URL param (forwarded by landing page)
    const gaParam = params.get('_ga');
    if (gaParam) {
      stored.ga_client_id = gaParam;
    } else {
      const gaCookie = getCookie('_ga');
      if (gaCookie) {
        // _ga cookie format: GA1.1.XXXXXXXXXX.XXXXXXXXXX — client ID is the last two parts
        const parts = gaCookie.split('.');
        if (parts.length >= 4) {
          stored.ga_client_id = `${parts[2]}.${parts[3]}`;
        }
      }
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch (e) {
    // sessionStorage may be unavailable (private browsing, etc.)
  }
}

export function getTrackingParams(): TrackingParams {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
  } catch (e) {
    return {};
  }
}
